export default __webpack_public_path__ + "static/media/handshake.9cd826b8.webp";